import type { AnalysisListItem } from '@/entities/analysis';
import { AnalysisCard } from '@/entities/analysis';
import { UserAvatar } from '@/entities/user';
import { AnimatedGridItem } from '@/shared/ui/animations';
import { useDeleteAnalysis, useRetryAnalysis } from '../../../../model/useAnalyses';

interface AnalysisGridViewProps {
  analyses: AnalysisListItem[];
}

export function AnalysisGridView({ analyses }: AnalysisGridViewProps) {
  const retryMutation = useRetryAnalysis();
  const deleteMutation = useDeleteAnalysis();

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(300px,1fr))] items-stretch gap-4 pb-4">
      {analyses.map((analysis, index) => (
        <AnimatedGridItem key={analysis.id} index={index} className="flex">
          <AnalysisCard
            analysis={analysis}
            creator={<UserAvatar userId={analysis.createdBy} size="mini" />}
            onRetry={(id) => retryMutation.mutate(id)}
            onDelete={(id, options) => deleteMutation.mutate(id, options)}
            isRetrying={retryMutation.isPending && retryMutation.variables === analysis.id}
            isDeleting={deleteMutation.isPending && deleteMutation.variables === analysis.id}
          />
        </AnimatedGridItem>
      ))}
    </div>
  );
}
